import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  project: {},
  projects: [],
  loading: false,
  overviewLoader: false,
  projectsLoading: false,
  projectLoading: false,
  projectPrograms: {},
  resources: {},
  error: "",
  budgetLoading: false,
  budgets: [],
  riskLoading: false,
  changeRequestLoading: false,
  changeRequests: [],
  reportLoading: false,
  report: "",
  confirmReportLoading: false,
  confirmedReport: null,
  allocatedResources: [],
  resourcesStatusLoading: false,
  metrix: [],
  metrixLoading: false,
  risks: [],
  riskStatusLoading: false,
  budgetPagination: {},
  changeRequestPagination: {},
  projectPagination: {},
  riskPagination: {},
  allocatedResourcesPagination: {},
  projectBudgetSummary: {},
  projectBudgetSummaryLoading: false,
  projectProgressSummary: {},
  projectProgressSummaryLoading: false,
});

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    // GET PROJECTS
    case ACTIONS.PROJECTS.PENDING: {
      return state.set("error", "").set("projectsLoading", true);
    }
    case ACTIONS.PROJECTS.SUCCESS: {
      if (action.data.pagination) {
        return state
          .set("projectsLoading", false)
          .set("error", "")
          .set("projects", action.data.data)
          .set("projectPagination", action.data.pagination);
      } else {
        return state
          .set("projectsLoading", false)
          .set("error", "")
          .set("projects", action.data);
      }
    }
    case ACTIONS.PROJECTS.ERROR: {
      return state.set("projectsLoading", false).set("error", action.error);
    }

    // GET PROJECT DETAILS
    case ACTIONS.GET_PROJECT_DETAILS.PENDING: {
      return state.set("error", "").set("overviewLoader", true);
    }
    case ACTIONS.GET_PROJECT_DETAILS.SUCCESS: {
      return state.set("overviewLoader", false).set("project", action.data);
    }
    case ACTIONS.GET_PROJECT_DETAILS.ERROR: {
      return state.set("overviewLoader", false).set("error", action.error);
    }
 
    // GET PROJECT BUDGET SUMMARY
    case ACTIONS.GET_PROJECT_BUDGET_SUMMARY.PENDING: {
      return state.set("error", "").set("projectBudgetSummaryLoading", true);
    }
    case ACTIONS.GET_PROJECT_BUDGET_SUMMARY.SUCCESS: {
      return state
        .set("projectBudgetSummaryLoading", false)
        .set("error", "")
        .set("projectBudgetSummary", action.data);
    }
    case ACTIONS.GET_PROJECT_BUDGET_SUMMARY.ERROR: {
      return state
        .set("projectBudgetSummaryLoading", false)
        .set("error", action.error);
    }
    // GET PROJECT PROGRESS SUMMARY
    case ACTIONS.GET_PROJECT_PROGRESS_SUMMARY.PENDING: {
      return state.set("error", "").set("projectProgressSummaryLoading", true);
    }
    case ACTIONS.GET_PROJECT_PROGRESS_SUMMARY.SUCCESS: {
      return state
        .set("projectProgressSummaryLoading", false)
        .set("error", "")
        .set("projectProgressSummary", action.data);
    }
    case ACTIONS.GET_PROJECT_PROGRESS_SUMMARY.ERROR: {
      return state
        .set("projectProgressSummaryLoading", false)
        .set("error", action.error);
    }

    // CREATE PROJECT
    case ACTIONS.CREATE_PROJECT.PENDING: {
      return state.set("projectLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_PROJECT.SUCCESS: {
      return state
        .set("projectLoading", false)
        .set("error", "")
        .set("projects", action.data.data)
        .set("projectPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_PROJECT.ERROR: {
      return state.set("error", action.error).set("projectLoading", false);
    }

    // DELETE PROJECT
    case ACTIONS.DELETE_PROJECT.PENDING: {
      return state.set("error", "").set("projectLoading", true);
    }
    case ACTIONS.DELETE_PROJECT.SUCCESS: {
      return state
        .set("projectLoading", false)
        .set("error", "")
        .set("projects", action.data.data)
        .set("projectPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_PROJECT.ERROR: {
      return state.set("error", action.error).set("projectLoading", false);
    }

    // UPDATE PROJECT
    case ACTIONS.UPDATE_PROJECT.PENDING: {
      return state.set("projectLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_PROJECT.SUCCESS: {
      if (action.data.type === "overview") {
        return state
          .set("error", "")
          .set("projectLoading", false)
          .set("project", action.data.data);
      } else {
        return state
          .set("error", "")
          .set("projectLoading", false)
          .set("projects", action.data.data)
          .set("projectPagination", action.data.pagination);
      }
    }
    case ACTIONS.UPDATE_PROJECT.ERROR: {
      return state.set("error", action.error).set("projectLoading", false);
    }

    // SORT PROJECTS
    case ACTIONS.SORT_PROJECTS.PENDING: {
      return state.set("error", "").set("projectsLoading", true);
    }
    case ACTIONS.SORT_PROJECTS.SUCCESS: {
      return state
        .set("error", "")
        .set("projectsLoading", false)
        .set("projects", action.data.data)
        .set("projectPagination", action.data.pagination);
    }
    case ACTIONS.SORT_PROJECTS.ERROR: {
      return state.set("error", action.error).set("projectsLoading", false);
    }

    // GET PROGRAM MANAGERS
    case ACTIONS.GET_PROGRAM_MANAGERS.PENDING: {
      return state.set("error", "").set("managers", action.data);
    }
    case ACTIONS.GET_PROGRAM_MANAGERS.SUCCESS: {
      return state.set("error", "").set("managers", action.data);
    }
    case ACTIONS.GET_PROGRAM_MANAGERS.ERROR: {
      return state.set("error", action.error);
    }

    // GET PROGRAM RESOURCES
    case ACTIONS.GET_RESOURCES.PENDING: {
      return state.set("error", "").set("resources", action.data);
    }
    case ACTIONS.GET_RESOURCES.SUCCESS: {
      return state.set("error", "").set("resources", action.data);
    }
    case ACTIONS.GET_RESOURCES.ERROR: {
      return state.set("error", action.error);
    }

    ////////////////////////////////////// PROJECT PROGRAMS //////////////////////////////////////

    // GET PROJECT PROGRAMS
    case ACTIONS.GET_PROGRAMS.PENDING: {
      return state.set("error", "").set("projectPrograms", action.data);
    }
    case ACTIONS.GET_PROGRAMS.SUCCESS: {
      return state.set("error", "").set("projectPrograms", action.data);
    }
    case ACTIONS.GET_PROGRAMS.ERROR: {
      return state.set("error", action.error);
    }

    ////////////////////////////////////// STATUS REPORT //////////////////////////////////////

    case ACTIONS.STATUS_REPORT.PENDING: {
      return state.set("error", "").set("reportLoading", true);
    }
    case ACTIONS.STATUS_REPORT.SUCCESS: {
      return state
        .set("reportLoading", false)
        .set("error", "")
        .set("report", action.data);
    }
    case ACTIONS.STATUS_REPORT.ERROR: {
      return state.set("reportLoading", false).set("error", action.error);
    }

    case ACTIONS.CLEAR_STATUS_REPORT: {
      return state.set("report", "");
    }

    case ACTIONS.CONFIRM_WSR_REPORT.PENDING: {
      return state.set("error", "").set("confirmReportLoading", true);
    }
    case ACTIONS.CONFIRM_WSR_REPORT.SUCCESS: {
      return state
        .set("confirmReportLoading", false)
        .set("error", "")
        .set("confirmedReport", action.data);
    }
    case ACTIONS.CONFIRM_WSR_REPORT.ERROR: {
      return state.set("confirmReportLoading", false).set("error", action.error);
    }


    ////////////////////////////////////// PROJECT RESOURCES //////////////////////////////////////

    // GET PROJECT RESOURCES
    case ACTIONS.PROJECT_RESOURCES.PENDING: {
      return state.set("error", "").set("resourcesStatusLoading", true);
    }
    case ACTIONS.PROJECT_RESOURCES.SUCCESS: {
      return state
        .set("resourcesStatusLoading", false)
        .set("error", "")
        .set("allocatedResources", action.data.data)
        .set("allocatedResourcesPagination", action.data.pagination);
    }
    case ACTIONS.PROJECT_RESOURCES.ERROR: {
      return state
        .set("resourcesStatusLoading", false)
        .set("error", action.error);
    }

    // CREATE PROJECT RESOURCES
    case ACTIONS.CREATE_PROJECT_RESOURCES.PENDING: {
      return state.set("resourcesStatusLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_PROJECT_RESOURCES.SUCCESS: {
      const resources = state.get("allocatedResources");
      resources.unshift(action.data);
      return state
        .set("resourcesStatusLoading", false)
        .set("error", "")
        .set("allocatedResources", resources);
    }
    case ACTIONS.CREATE_PROJECT_RESOURCES.ERROR: {
      return state
        .set("resourcesStatusLoading", false)
        .set("error", action.error);
    }

    // UPDATE PROJECT RESOURCES
    case ACTIONS.UPDATE_PROJECT_RESOURCES.PENDING: {
      return state.set("resourcesStatusLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_PROJECT_RESOURCES.SUCCESS: {
      return state
        .set("resourcesStatusLoading", false)
        .set("error", "")
        .set("allocatedResources", action.data);
    }
    case ACTIONS.UPDATE_PROJECT_RESOURCES.ERROR: {
      return state
        .set("resourcesStatusLoading", false)
        .set("error", action.error);
    }

    // DELETE PROJECT RESOURCES
    case ACTIONS.DELETE_PROJECT_RESOURCE.PENDING: {
      return state.set("error", "").set("resourcesStatusLoading", true);
    }
    case ACTIONS.DELETE_PROJECT_RESOURCE.SUCCESS: {
      return state
        .set("error", "")
        .set("resourcesStatusLoading", false)
        .set("allocatedResources", action.data);
    }
    case ACTIONS.DELETE_PROJECT_RESOURCE.ERROR: {
      return state
        .set("error", action.error)
        .set("resourcesStatusLoading", false);
    }

    // SORT PROJECT RESOURCES
    case ACTIONS.SORT_PROJECT_RESOURCES.PENDING: {
      return state.set("error", "").set("resourcesStatusLoading", true);
    }
    case ACTIONS.SORT_PROJECT_RESOURCES.SUCCESS: {
      return state
        .set("error", "")
        .set("resourcesStatusLoading", false)
        .set("allocatedResources", action.data.data)
        .set("allocatedResourcesPagination", action.data.pagination);
    }
    case ACTIONS.SORT_PROJECT_RESOURCES.ERROR: {
      return state
        .set("error", action.error)
        .set("resourcesStatusLoading", false);
    }

    ////////////////////////////////////// HEALTH STATUS //////////////////////////////////////

    // GET METRIX
    case ACTIONS.METRIX.PENDING: {
      return state.set("error", "").set("metrixLoading", true);
    }

    case ACTIONS.METRIX.SUCCESS: {
      return state.set("error", "").set("metrixLoading", false).set("metrix", action.data);
    }

    case ACTIONS.METRIX.ERROR: {
      return state.set("error", action.error).set("metrixLoading", false);
    }

    case ACTIONS.HEALTH_STATUS_FILTER.PENDING: {
      return state.set("error", "").set("metrixLoading", true);
    }

    case ACTIONS.HEALTH_STATUS_FILTER.SUCCESS: {
      return state.set("error", "").set("metrixLoading", false).set("metrix", action.data);
    }

    case ACTIONS.HEALTH_STATUS_FILTER.ERROR: {
      return state.set("error", action.error).set("metrixLoading", false);
    }

    // UPDATE METRIX

    case ACTIONS.UPDATE_KPI.PENDING: {
      return state.set("error", "");
    }

    case ACTIONS.UPDATE_KPI.SUCCESS: {
      return state.set("error", "");
      // return state.set("error", "").set("metrix", action.data);
    }

    case ACTIONS.UPDATE_KPI.ERROR: {
      return state.set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
